import cookies from "js-cookie";
import { getEditorWidthSetting, getLinkShareRangeSetting } from "@/api/h5/file";
import "@toca/toca-wiki-template/dist/style.css";
import {
    TocaWikiPreferenceSetting
} from "@toca/toca-wiki-template";

export function showPreferenceSetting(currentUser, isEditor, isLogin, fileId, cloudI18n, onCloseDialog, onUpdateFullScreenType, onUpdateLinkShareRange) {
    setTimeout(async () => {
        const cookie = {
            token: cookies.get("token"),
            spaceId: cookies.get("spaceId"),
            userId: cookies.get("userId"),
            deviceId: cookies.get("deviceId"),
            memberUniqueId: cookies.get("memberUniqueId") || currentUser.id,
            memberId: cookies.get("memberId") || currentUser.id,
        };
        let env = process.env.VUE_APP_STATIC_NODE_ENV;
        let showSettings = ['linkShareRange'];
        if (isEditor && isLogin) {
            showSettings = ['fullWidth', 'linkShareRange'];
        }
        const [widthResp, linkShareRangeResp] = await Promise.all([getEditorWidthSetting(fileId), getLinkShareRangeSetting(fileId)]);
        if (widthResp.code == 200 && linkShareRangeResp.code == 200) {
            const fullScreenType = widthResp.data.settingsValue;
            const linkShareRange = linkShareRangeResp.data.settingsValue;
            new TocaWikiPreferenceSetting("#preference_setting_dialog",
                {
                    locale: cloudI18n,
                    env: env,
                    userInfo: cookie,
                    fileId: fileId,
                    fullScreenType: fullScreenType,
                    isWiki: false,
                    linkShareRange: linkShareRange,
                    showSettings: showSettings,
                    onCloseDialog: () => {
                        // this.showSetting = false;
                        if (onCloseDialog) {
                            onCloseDialog();
                        }
                    },
                    onUpdateFullScreenType: (type) => {
                        if (onUpdateFullScreenType) {
                            onUpdateFullScreenType(type);
                        }
                    },
                    onUpdateLinkShareRange: (range) => {
                        if (onUpdateLinkShareRange) {
                            onUpdateLinkShareRange(range);
                        }
                    },
                    onUpdateFullScreenType: (type) => {
                        if (onUpdateFullScreenType) {
                            onUpdateFullScreenType(type);
                        }
                    },
                    onUpdateLinkShareRange: (range) => {
                        if (onUpdateLinkShareRange) {
                            onUpdateLinkShareRange(range);
                        }
                    },
                });
        }
    }, 0);
}